import React from "react";
import Icon from "./Icon";

// Boutons de la maquette Scan to Charge.
const VARIANTS = {
  // En version web, le bouton inactif est gris (maquette web), pas seulement atténué.
  primary:
    "h-14 bg-qv-brand text-white text-base shadow-qv-cta hover:bg-qv-brand-hover md:disabled:bg-qv-line md:disabled:text-[#8B8B93] md:disabled:opacity-100 md:disabled:shadow-none",
  secondary: "h-[52px] bg-white border-[1.5px] border-qv-brand text-qv-brand text-[15px] hover:bg-qv-brand-50",
  neutral: "h-[52px] bg-white border-[1.5px] border-qv-line text-qv-ink text-[15px] hover:bg-qv-canvas",
  danger: "h-[52px] bg-white border-[1.5px] border-qv-line text-qv-red text-[15px] hover:border-qv-red hover:bg-qv-red-50",
  dangerSolid: "h-[52px] bg-qv-red text-white text-[15px] hover:brightness-95",
  whatsapp: "h-[52px] bg-qv-whatsapp text-white text-[15px] hover:brightness-95",
};

const BASE =
  "w-full rounded-lg flex items-center justify-center gap-2 px-4 font-montserrat font-semibold " +
  "no-underline transition-colors disabled:opacity-50 disabled:cursor-not-allowed " +
  "focus:outline-none focus-visible:ring-2 focus-visible:ring-qv-brand focus-visible:ring-offset-2";

export default function Button({
  variant = "primary",
  icon,
  href,
  loading = false,
  disabled = false,
  className = "",
  children,
  ...rest
}) {
  // Un bouton en cours de traitement garde sa couleur (maquette : « Vérification de
  // votre carte… » en violet atténué), il n'est pas présenté comme inactif.
  const loadingClasses = loading && variant === "primary" ? "!opacity-75 md:disabled:!bg-qv-brand md:disabled:!text-white" : "";
  const classes = `${BASE} ${VARIANTS[variant]} ${loadingClasses} ${className}`;
  const content = (
    <>
      {loading ? (
        <span
          className="h-5 w-5 rounded-full border-2 border-current border-t-transparent animate-spin"
          aria-hidden="true"
        />
      ) : (
        icon && <Icon name={icon} size={20} />
      )}
      {children}
    </>
  );

  if (href) {
    return (
      <a href={href} className={classes} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <button type="button" className={classes} disabled={disabled || loading} {...rest}>
      {content}
    </button>
  );
}
